import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TreeNode } from 'primeng/primeng';

@Component({
  selector: 'app-departaments-modal',
  templateUrl: './departaments-modal.component.html',
  styleUrls: ['./departaments-modal.component.css']
})
export class DepartamentsModalComponent implements OnInit {
  @Output() onSaveDepartaments = new EventEmitter<any>();

  display = false;
  departaments: TreeNode[] = []
  selectedDepartaments: TreeNode[] = [];

  constructor() {}

  ngOnInit() {}

  show() {
    this.display = true
  }

  hide() {
    this.display = false
  }

  onCallSaveDepartaments(){
    this.onSaveDepartaments.emit();
  }

  selectAllDepartments() {
    this.departaments.forEach(v => this.selectedDepartaments.push(v));
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/departaments-modal/departaments-modal.component.ts